


























































































































































































































































































































import VueOptions from '@utils/VueOptions'
import TitlePatternUtility from '@utils/TitlePatternUtility'
import PricingModel from '@services/PricingModel'
import CalendarService from '@services/CalendarService'
import CalendarUtils from '@utils/calendar'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import MiniCalendar from '@ui/Calendar/MiniCalendar'
import LineItem from './LineItem'
import AddonLineItem from './AddonLineItem'
import AddonCreator from './AddonCreator'
import VariableSetEditor from '@ui/Campaign/pipeline/VariableSetEditor'

settings =
  name: "CampaignCheckoutEventEdit"

  resources:
    campaign:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId'
      fetch: false

    cart:
      resourceName: 'shopping_cart'
      slug: 'campaigns/:campaignId/shopping_cart'
      fetch: false

    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:listingId'

    activation_plan:
      resourceName: 'activation_plan'
      slug: 'campaigns/:campaignId/activation_plans/:activationPlanId'
      fetch: false

  vue:
    props: ['show', 'lineItems', 'actions', 'options']

    components: {
      Modal,
      MiniCalendar,
      LineItem,
      AddonCreator,
      AddonLineItem,
      VariableSetEditor,
    }

    data: ->
      activationDates: []
      snapToFit: null
      isLocked: null

      tab: null
      showAllInstructions: false
      showAllTerms: false

      maxPalletsModal:
        show: false
        value: null

    mounted: ->
      @initializeTab()
      @initializeSnapToFit()
      @initializeIsLocked()

    computed:
      modalWidth: ->
        w = 'md' if @currentMemberIsSuperUser()
        w ||= 'md'
        w

      campaignId: -> @$route.params.campaignId
      listingId: -> @$route.params.listingId
      segment: -> @$route.query.segment || @options?.segment
      audienceListingId: -> @ctxAudienceListing(@lineItems[0]).id
      activationPlanId: -> @options?.activationPlanId || "#{@campaignId}:#{@listingId}:#{@segment}"

      audienceListing: ->
        return null unless @audience_listing
        l = @audience_listing
        l.calendar_dates = CalendarService.normalizeEvents l.calendar_dates
        l

      title: ->
        TitlePatternUtility.formatListingTitle @audienceListing

      engagementCapacity: ->
        capacity = @audienceListing.engagement_capacity[@segment]
        capacity ||= @audienceListing.engagement_capacity['default']
        capacity

      dailyCapacity: ->
        return null if @isOmnichannel
        capacity = @engagementCapacity.sampling_capacity.daily if @campaignHasSampling
        capacity ||= @engagementCapacity.reach.daily if @campaignHasOnsite
        capacity
      defaultCapacity: ->
        return null if @isOmnichannel
        capacity = @engagementCapacity.sampling_capacity.default if @campaignHasSampling
        capacity ||= @engagementCapacity.reach.default if @campaignHasOnsite
        capacity

      campaignHasSampling: -> @campaign.creatives.product_sampling?
      campaignHasOnsite: -> @campaign.creatives.onsite_space?

      totalPriceInDollars: ->
        price = 0
        price += lineItem.total_price_in_dollars for lineItem in @lineItems
        price

      addonPricingModels: -> ['addon_serve_cold', 'addon_assembly', 'addon_promo_distribution']

      omnichannelAddonPricingModels: ->
        (@audienceListing?.omnichannel_types || []).map((type) -> "addon_#{type}")

      hasAdditionalOrganizerTOS: ->
        @audienceListing?.partner_additional_terms?.length

      earliestListingDate: ->
        earliestListing = @campaign.target.audience_partnership_earliest_listing || 0
        dayjs().add(earliestListing, 'days').toDate()

      earliestAvailabilityWindows: ->
        windows = @audienceListing.availability_windows
        earliestDate = dayjs(@earliestListingDate).subtract(1, 'day')
        windows.filter((avWindow) => dayjs(avWindow.date).isAfter(earliestDate))

      optionsForCalendar: ->
        initialDate: new Date(@activation_plan.available_dates[0]?.starts_on) if @activation_plan.available_dates[0]
        selectable: false
        dayCellClassNames: @dayCellClassNames
        eventContent: @eventContent
        eventClick: @hiClickCalendarEvent

      campaignHasAssembly: ->
        @campaign.creatives.product_sampling?[0]?.activation_snapshot.supplier_provisions.assembly?.required

      isOmnichannel: ->
        @lineItems[0].pricing_model is 'omnichannel'

      isProductSampling: ->
        @lineItems[0].space_name.includes 'product_sampling'

      canUnlockOffer: ->
        !!(@$store.member.permissions || {}).accounting

      canAddCredit: ->
        @actions?.addCreditToLineItem?

      selectedShippingPlan: ->
        @lineItems[0].shipping_plan[@lineItems[0].shipping_plan.type]

      shippingCheckbox: ->
        { accepts_pallets, max_pallet_count } = @audienceListing
        text = "Accepts max #{max_pallet_count} pallets" if accepts_pallets and max_pallet_count
        text ||= "Accepts Pallets"

        {
          text,
          iconClass: 'fal fa-pallet-alt'
          eventHas: accepts_pallets
        }

    methods:
      initializeTab: ->
        @tab = 'pricing' if @lineItems.length > 1
        @tab ||= @lineItems[0].id

      initializeSnapToFit: ->
        value = true
        value = false if @lineItems[0].locked
        value = false if @isOmnichannel
        @snapToFit = value

      initializeIsLocked: ->
        @isLocked = @lineItems[0].locked

      initializeActivationDates: ->
        start = @activation_plan.available_dates[0]?.starts_on
        end = @activation_plan.available_dates[@activation_plan.available_dates.length - 1]?.starts_on
        @activationDates = [start, end] if start and end

      hiSaveMaxPallets: ->
        @maxPalletsModal.show = false
        @actions.updateMaxPalletCount @lineItems[0], @audienceListing.max_pallet_count

      hiClickCalendar: (jsEvent) ->
        @showDatePicker() if jsEvent.target.closest('.fc-view')

      hiClickCalendarEvent: (ev) ->
        ev.jsEvent.stopPropagation()
        @showDatePicker()

      showDatePicker: ->
        @$refs.datePicker.showPicker()

      variablesCount: (lineItem) -> 
        Object.values(lineItem?.variables || {}).length

      # eventForLineItem: (lineItem) -> @event or @ctxEvent lineItem
      pricingTable: ->
        table = @audienceListing.pricing_table
        table ||= @ctxPricingTable @audienceListing
        table
      # spaceFor: (lineItem) -> @audienceListing?.spaces[lineItem.space_name]
      spaceTypeFor: (lineItem) -> lineItem.space_name.split(':')[0]

      spacePriceFor: (lineItem) -> lineItem.total_price_in_dollars
      unitsFor: (lineItem, pricingModel) -> @pricingTable()?[pricingModel]?.units

      rateFor: (lineItem, pricingModel) ->
        parseInt(@pricingTable()?[pricingModel]?.price_in_cents) / 100

      actionsForLineItem: ->
        actions = {
          hiUpdateQuantity: @hiUpdateLineItemQuantity,
          hiUpdateDiscount: @hiPromptUpdateLineItemDiscount,
          hiUpdateOriginalPrice: @hiUpdateOriginalPrice,
          hiUpdateOriginalPayout: @hiUpdateOriginalPayoutTrigger
        }
        actions.hiRemove = @hiRemoveLineItem if @lineItems.length > 1
        actions

      actionsForAddon: (lineItem) ->
        {
          hiRemove: @hiRemoveAddonFn(lineItem),
          hiUpdateQuantity: @actions.hiUpdateAddonQuantityFn(lineItem),
          hiUpdateDiscount: @hiPromptUpdateAddonDiscountFn(lineItem),
          hiUpdateOriginalPrice: @hiUpdateAddonOriginalPriceFn(lineItem),
          hiUpdateOriginalPayout: @hiUpdateAddonOriginalPayoutFn(lineItem)
        }
      addonMakersForLineItem: (lineItem) ->
        addonMakers = {}

        if @isOmnichannel
          for addonPricingModel in @omnichannelAddonPricingModels
            addonMakers[addonPricingModel] =
              pricing_model: addonPricingModel
              units: @unitsFor(lineItem, addonPricingModel)
              rate: @rateFor(lineItem, addonPricingModel)
              create: @hiAddOmnichannelLineItem(lineItem, addonPricingModel)
        else
          addonMakers.addon_serve_cold =
            pricing_model: 'addon_serve_cold'
            units: 'item'
            rate: @rateFor(lineItem, 'addon_serve_cold')
            create: () => @hiAddServeColdLineItem(lineItem)

          addonMakers.addon_assembly = {
            pricing_model: 'addon_assembly'
            units: 'asm'
            rate: @rateFor(lineItem, 'addon_assembly')
            create: () => @hiAddAssemblyLineItem(lineItem)
          } if @campaignHasAssembly

          addonMakers.addon_promo_distribution =
            pricing_model: 'addon_promo_distribution'
            units: 'item'
            rate: @rateFor(lineItem, 'addon_promo_distribution')
            create: () => @hiAddPromoLineItem(lineItem)

        if @currentMemberIsSuperUser()
          addonMakers.addon_custom = 
            pricing_model: 'addon_custom',
            units: 'event',
            rate: @rateFor(lineItem, 'addon_custom'),
            create: () => @hiAddCustomLineItem(lineItem)

        for addonPricingModel in [...@addonPricingModels, ...@omnichannelAddonPricingModels]
          addon = lineItem.addons?.find((addon) -> addon.pricing_model is addonPricingModel)
          delete addonMakers[addonPricingModel] if addon

        Object.values addonMakers

      labelForShippingPlanType: (lineItem, type) ->
        shippingPlan = lineItem.shipping_plan
        { formatNumber } = @$options.filters

        { shipments } = shippingPlan[type]
        shipmentsCopy = "#{shipments.length} shipment" if shipments.length is 1
        shipmentsCopy ||= "#{shipments.length} shipments"

        label = ""

        switch type
          when 'cases'
            { case_quantity } = shippingPlan.cases
            label = "#{case_quantity} cases in #{shipmentsCopy}"
          when 'full_pallets'
            { pallet_quantity, total_case_quantity } = shippingPlan.full_pallets
            label = "#{formatNumber(pallet_quantity)} pallets in #{shipmentsCopy}"
            label += " (#{formatNumber(total_case_quantity)} cases total)"
          when 'pallets_partial'
            { pallet_quantity, total_case_quantity } = shippingPlan.pallets_partial
            label = "#{formatNumber(pallet_quantity)} pallets in #{shipmentsCopy}"
            label += " (#{formatNumber(total_case_quantity)} cases total)"
          when 'pallets_and_cases'
            { enabled, pallet_quantity, total_case_quantity, overflow_cases_quantity } = shippingPlan.pallets_and_cases
            label = "#{formatNumber(pallet_quantity)} pallets"
            label += " + #{overflow_cases_quantity} cases" if enabled and overflow_cases_quantity > 0
            label +=  " in #{shipmentsCopy}"
            label += " (#{formatNumber(total_case_quantity)} cases total)"
          when 'items'
            { plan_capacity } = shippingPlan.items
            label = "#{formatNumber(plan_capacity)} items in #{shipmentsCopy}"

        label

      formatShippingPlanType: (type) ->
        switch type
          when 'pallets_partial'
            "Partial Pallet"
          when 'pallets_and_cases'
            "Pallets & Cases"
          else
            @$options.filters.formatTitle(type)

      canSelectShippingPlan: (lineItem, type) ->
        { case_size, pallet_size } = lineItem.shipping_plan
        { case_quantity } = lineItem.shipping_plan.cases
        { pallet_quantity } = lineItem.shipping_plan[type]
        return case_size > 0 if type is 'cases' and case_quantity > 0
        return pallet_size > 0 if type.includes('pallets') and pallet_quantity > 0 and @audienceListing.accepts_pallets
        return true if type is 'items'

      shipmentsFor: (lineItem, type) ->
        plan = lineItem.shipping_plan
        plan[type].shipments

      hiRemoveLineItem: (lineItem) ->
        @actions.removeLineItem(lineItem)
      hiUpdateLineItemQuantity: (lineItem) ->
        [startDate] = @activationDates
        return unless startDate
        @actions.updateLineItemQuantity(lineItem, startDate, @snapToFit)
      hiPromptUpdateLineItemDiscount: (lineItem) ->
        @actions.promptUpdateLineItemDiscount(lineItem)

      # hiUpdateActivationDate: ->
      #   @actions.updateActivationDate(lineItem) for lineItem in @lineItems

      hiAddOmnichannelLineItem: (lineItem, pricingModel) -> () => @actions.addAddonLineItem(lineItem, pricingModel)
      hiAddAssemblyLineItem: (lineItem) -> @actions.addAddonLineItem(lineItem, 'addon_assembly')
      hiAddServeColdLineItem: (lineItem) -> @actions.addAddonLineItem(lineItem, 'addon_serve_cold')
      hiAddPromoLineItem: (lineItem) -> @actions.addAddonLineItem(lineItem, 'addon_promo_distribution')
      hiAddCustomLineItem: (lineItem) -> @actions.addAddonLineItem(lineItem, 'addon_custom')

      hiRemoveAddonFn: (lineItem) ->
        (addon) =>
          @actions.removeAddon(lineItem, addon)
      hiPromptUpdateAddonDiscountFn: (lineItem) ->
        (addon) =>
          @actions.promptUpdateAddonDiscount(lineItem, addon)

      hiUpdateOriginalPrice: (lineItem) -> @actions.updateOriginalPriceTrigger(lineItem)
      hiUpdateOriginalPayoutTrigger: (lineItem) -> @actions.updateOriginalPayoutTrigger(lineItem)

      hiUpdateAddonOriginalPriceFn: (lineItem) ->
        (addon) =>
          @actions.updateAddonOriginalPriceTrigger(lineItem, addon)

      hiUpdateAddonOriginalPayoutFn: (lineItem) ->
        (addon) =>
          @actions.updateAddonOriginalPayoutTrigger(lineItem, addon)

      hiSetVariableFn: (lineItem) ->
        (name, value) => @actions.setVariable(lineItem, name, value)

      hiClose: ->
        @fetch 'cart'
        @$router.back()

      hiChangeActivationDates: (dates) ->
        [startDate, endDate] = dates
        lineItem = @lineItems[0]
        @actions.updateActivationDatesPlan lineItem, startDate, endDate, @snapToFit

      hiUnlockOffer: ->
        @isLocked = false

      hiAddCredit: ->
        @actions.addCreditToLineItem()

      hiSelectShippingPlan: (lineItem, type) ->
        @actions.selectShippingPlan lineItem, type, @snapToFit

      dayCellClassNames: ({ date, isPast, ...args }) ->
        classes = []

        if !isPast
          dateIsInPlan = @activation_plan.available_dates.some(({ starts_on }) -> dayjs(starts_on).isSame(date))
          classes.push 'planned' if dateIsInPlan

        classes.push 'fc-day-disabled' if !classes.length
        classes

      capacityForDay: (dateStr) ->
        dayOfWeek = CalendarService.shortWeekdayForDate dateStr
        monthAndDay = dayjs(dateStr).format('M-D')
        monthDay = dayjs(dateStr).format('D')
        
        capacity = @dailyCapacity?[dateStr]
        capacity ||= @dailyCapacity?["last_day_of_month"] if CalendarUtils.weekOrdinality(dateStr).isLastDay
        capacity ||= @dailyCapacity?[monthAndDay]
        capacity ||= @dailyCapacity?[monthDay]
        capacity ||= @dailyCapacity?[dayOfWeek]
        capacity ||= @defaultCapacity.daily
        # capacity ||= @defaultCapacity.weekly / 7 # 7 has to be number of days on week
        Math.ceil capacity

      eventContent: ({ event }, createElement) ->
        capacity = @capacityForDay event.startStr 
        return '' unless capacity
        { html: "<div class='absolute right-0 bottom-0 p-1 text-grey-darkest text-xs'><i class='fas fa-user mr-1 opacity-35'></i><span class='font-bold'>#{capacity}</span></div>"}

    watch:
      show: (value) -> @hiClose() unless value

      activation_plan: (value) ->
        @initializeActivationDates()

export default VueOptions.vue settings
